import React from "react";
import { Box, Typography, IconButton, Tooltip } from "@mui/material";
import { Edit as EditIcon, Delete as DeleteIcon } from "@mui/icons-material";

const WidgetHeader = ({ title, onEdit, onDelete, showDragHandle = false }) => {
  return (
    <Box
      display="flex"
      justifyContent="space-between"
      alignItems="center"
      mb={2}
    >
      <Typography
        variant="h6"
        component="h3"
        className={showDragHandle ? "widget-drag-handle" : undefined}
        sx={
          showDragHandle
            ? { flex: 1, cursor: "grab", userSelect: "none", touchAction: "none" }
            : undefined
        }
      >
        {title}
      </Typography>
      <Box display="flex" gap={1} sx={{ zIndex: 1000, flexShrink: 0 }}>
        {onEdit && (
          <Tooltip title="Edit Widget">
            <IconButton
              size="small"
              onClick={onEdit}
              sx={{
                backgroundColor: "rgba(255, 255, 255, 0.06)",
                "&:hover": {
                  backgroundColor: "rgba(255, 255, 255, 0.1)",
                },
              }}
            >
              <EditIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        )}
        {onDelete && (
          <Tooltip title="Delete Widget">
            <IconButton
              size="small"
              onClick={onDelete}
              sx={{
                backgroundColor: "rgba(255, 255, 255, 0.06)",
                "&:hover": {
                  backgroundColor: "rgba(255, 255, 255, 0.1)",
                },
              }}
            >
              <DeleteIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        )}
      </Box>
    </Box>
  );
};

export default WidgetHeader;
